import React, { memo, useEffect, useState } from 'react';
import theme from './style';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import AddIcon from '@material-ui/icons/Add';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import RemoveIcon from '@material-ui/icons/Remove';
import {
  openPendingPDFWindow,
  triggerPDFOpen,
  downloadSupplierInvoicePDF,
} from '../../redux/actions/supplierInvoices';
import {useConfig} from "../../context/configContext";
const PDFPreview = (props) => {
  const config = useConfig();
  const classes = theme(config);
  const { id } = props;
  const [scale, setScale] = useState(8);
  const [pdfUrl, setPdfUrl] = useState(null);

  const {
    access_token,
    refresh_token,
    downloadSupplierInvoicePDF
  } = props;
  const fetchPDF = () => {
    return downloadSupplierInvoicePDF({
      access_token,
      refresh_token,
      id: id,
      type: 'pdfSupplierInvoice'
    });
  }

  const loadPreview = async () => {
    try {
      const asset = await fetchPDF();
      if (!asset || !asset.blob) {
        return;
      }

      const nextUrl = window.URL.createObjectURL(asset.blob);
      setPdfUrl(nextUrl);
    } catch (error) {
    }
  }

  const handleOpenPDF = async () => {
    const previewWindow = openPendingPDFWindow();
    try {
      const asset = await fetchPDF();
      if (!asset) {
        if (previewWindow) {
          previewWindow.close();
        }
        return;
      }
      triggerPDFOpen(asset, previewWindow);
    } catch (error) {
      if (previewWindow) {
        previewWindow.close();
      }
    }
  }

  useEffect(() => {
    loadPreview();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, access_token, refresh_token]);

  useEffect(() => {
    return () => {
      if (pdfUrl) {
        window.URL.revokeObjectURL(pdfUrl);
      }
    };
  }, [pdfUrl]);
  
  return (
    <React.Fragment>
      <div className={classes.controlers}>
        <AddIcon onClick={() => setScale((scale + 1) < 20 ? (scale + 1) : scale)} />
        <RemoveIcon onClick={() => setScale((scale - 1) > 0 ? (scale - 1) : scale)} />
        <OpenInNewIcon onClick={handleOpenPDF} />
      </div>
      <div className={classes.container}>
        {pdfUrl && (
          <embed
            key={`${pdfUrl}-${scale}`}
            src={pdfUrl}
            type="application/pdf"
            style={{ width: '100%', height: '100%', border: 0 }}
          />
        )}
      </div>
    </React.Fragment>
  );

}
PDFPreview.propTypes = {
  id: PropTypes.string.isRequired,
}

const mapStateToProps = store => ({
  access_token: store.login.access_token,
  refresh_token: store.login.refresh_token,
});
const mapDispatchToProps = dispatch =>
  bindActionCreators({
    downloadSupplierInvoicePDF
  }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(memo(PDFPreview));
